export const MOUNT_POINT = "anna_diam_config";
export const SINGLE_DIAM_MOUNT_POINT = "anna_diam_config_single";
export const PRODUCT_OPTIONS_CONTAINER = "[data-product-options-container]";
export const PRODUCT_FORM = "[data-product-form-regular]";
export const PRODUCT_QUANTITY_WRAPPER = "[data-quantity-wrapper]";
export const ADD_TO_CART_BUTTON = "[data-product-atc]";
export const ADD_TO_CART_BUTTONV2 = ".submit-button > button";
export const GIA_WRAPPER_ID = "giaCertificate";
export const STOCK_LEVEL_WRAPPER = ".stock-level--wrapper";
export const TOTAL_PRICE_WRAPPER = "price--main";
export const TOTAL_PRICE_WRAPPERV2 = '[data-slot="product-main-price"]';
